import { AdminView } from '@pages/admin-view/admin-view-routes.names';

export const Exceptions = 'exceptions';

export const AdminExceptions = `${AdminView}/${Exceptions}`;
